<template>
  <div class="circlelist_container">
    <div class="circletabbox" ref="circletabbox">
      <ul class="circleul">
        <li :class="liindex==0 ? 'active' : '' " @click="gotourl(0)">
          <span>推荐</span>
        </li>
        <li :class="liindex==1 ? 'active' : '' " @click="gotourl(1)">
          <span>关注</span>
        </li>
        <li :class="liindex==2 ? 'active' : '' " @click="gotourl(2)">
          <span>最近访问</span>
        </li>
      </ul>
    </div>

    <div class="circlesobox" ref="circlesobox">
      <dl>
        <dt>
          <van-search left-icon="https://api.xianpipa.com/xianpipa/images/contacts_icon_search.png" background="#f8f8f8" placeholder="搜索您感兴趣的圈子" @click="gosearchcircle" v-model="value" shape="round" />
        </dt>
        <dd @click="gotocreatcircle">
          <van-icon name="plus" />
          <span>申请圈子</span>
        </dd>
      </dl>
    </div>
    <div class="circlesidebar" :style="'height:calc(100% - ' + boxheight +'px'">
      <van-sidebar v-model="activeKey">
        <div v-for="(item,index) in circlename" :key="index">
          <van-sidebar-item :title="item.title" @click="gotocirclelist(item.id)" />
        </div>
      </van-sidebar>
    </div>
    <div class="circlelistbox" ref="reference" :style="'height:calc(100% - ' + boxheight +'px'">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="circlenrbox" v-for="(item,index) in tjcirclelist" :key="index">
          <div class="circle-cell">
            <div class="circle-cell-pic" @click="gotocirclecontent(item.id)">
              <img :src="item.avatar_url" />
              <div class="circle-cell-pic-no circle-cell-pic-no01" v-if="item.sort == 1">
                <img :src="sortno1" />
                No.{{item.sort}}
              </div>
              <div class="circle-cell-pic-no circle-cell-pic-no02" v-if="item.sort == 2">
                <img :src="sortno2" />
                No.{{item.sort}}
              </div>
              <div class="circle-cell-pic-no circle-cell-pic-no03" v-if="item.sort == 3">
                <img :src="sortno3" />
                No.{{item.sort}}
              </div>
              <div class="circle-cell-pic-no" v-if="item.sort > 3 && item.sort < 11">No.{{item.sort}}</div>
            </div>
            <div class="circle-cell-name" @click="gotocirclecontent(item.id)">
              <div class="cname">{{item.title}}</div>
              <div>
                <span class="ctext1">{{item.message_num}}帖子</span>
                <span class="ctext2">{{item.fans_num}}粉丝</span>
              </div>
            </div>
            <div class="circle-cell-fllow">
              <button @click="favorclick(item.id)" v-if="tjcirclelist[index].is_follow== 0 || tjcirclelist[index].is_follow== 2">关注</button>
              <button @click="favorclick(item.id)" class="active" v-else>已关注</button>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
import { Toast } from "vant";
import {
  getcircleclassify,
  getcircledylist,
  getothercirclelist,
  gettofollowcircle
} from "../../api/api";

export default {
  data () {
    return {
      activeKey: 0,
      value: "",
      circleNo: 0,
      circlename: [], //圈子列表名
      tjcirclelist: [], //推荐圈子列表
      nofollow: true, //当没有关注的状态
      myfollowcircle: [], //我关注的圈子
      Recentvisits: [], //最近访问的圈子
      noRecentvisits: true, //没有最近访问的圈子
      objnum: 1,
      is_follow: 0,
      scrollTop: 0, //滚动到顶部
      page: 0, //分页请求
      scroll_height: 0,
      liindex: 0,
      loading: false,
      finished: true,
      pageCount: 0,
      cirid: 0,
      sortno1: require("../../assets/images/dynamic_icon_a.png"),
      sortno2: require("../../assets/images/dynamic_icon_b.png"),
      sortno3: require("../../assets/images/dynamic_icon_c.png"),
      titlename: "圈子列表",
      boxheight: 0, //列表的高度
    };
  },
  beforeRouteEnter (to, from, next) {
    if (from.name == "circlecontent") {
      to.meta.keepAlive = true;
      //to.meta.isBack = true;
    }
    next();
  },
  created () {
    document.title = this.titlename;
    this.changetabbar();
  },
  mounted () {
    let id = this.$route.query.id;
    if (id) {
     this.cirid = id
    }
    let navbarHeight =
      this.$refs.circletabbox.offsetHeight +
      this.$refs.circlesobox.offsetHeight;
    this.boxheight = navbarHeight;
    this.yikaishi();
  },
  methods: {
    gotocirclecontent (id) {
      this.$router.push({
        path: "/circlecontent",
        query: {
          id: id
        }
      });
    },
    gotocirclelist (e) {
      this.$refs.reference.scrollTop = 0;
      let that = this;
      this.cirid = e;
      getothercirclelist(e, 0).then(res => {
        if (res.data.code == 200) {
          that.finished = false;
          that.tjcirclelist = res.data.data.list;
          that.pageCount = res.data.data.pageCount;
          that.page = 0;
        } else {
        }
      });
    },
    gosearchcircle () {
      this.$router.push({
        name: "searchcircle"
      });
    },
    gotocreatcircle () {
      this.$router.push({
        name: "creatcircle"
      });
    },
    /**
     * 关注
     */
    favorclick: function (id) {
      var item_id = id; //此处找到列表的id
      this.goodfllow(item_id);
    },

    yikaishi () {
      var that = this;
      Toast.loading({
        mask: true,
        message: "加载中..."
      });
      //这边要改
      let cirid = this.cirid;
      getothercirclelist(cirid)
        .then(res => {
          if (res.data.code == 200) {
            that.tjcirclelist = res.data.data.list;
            that.pageCount = res.data.data.pageCount;
            that.page = 0;
            that.circlename = res.data.data.group;
            that.circlename.filter((item, i) => {
                if (item.id == cirid) {
                  that.activeKey = i
                }
              });
            that.finished = false;
            Toast.clear();
          } else {
            Toast.fail("加载失败，请刷新！");
          }
        })
        .catch(err => {
        });
    },

    //关注圈子和取消关注圈子
    goodfllow: function (item_id) {
      var that = this;
      var show; //传递到数据库点赞的状态

      if (localStorage.getItem("okfollow")) {
        var cookie_mid = localStorage.getItem("okfollow").split(",");
      } else {
        var cookie_mid = [];
      }
      //var cookie_mid = localStorage.getItem('okfollow').split(',') || []; //获取全部点赞的mid
      var newmessage = [];

      for (var i = 0; i < that.tjcirclelist.length; i++) {
        if (that.tjcirclelist[i].id == item_id) {
          //遍历找到对应的id

          var num = that.tjcirclelist[i].is_follow; //当前赞数
          var isshow; //点赞的状态
          if (cookie_mid.includes(item_id)) {
            //说明已经点过赞,取消赞

            for (var j = 0; j < cookie_mid.length; j++) {
              if (cookie_mid[j] == item_id) {
                cookie_mid.splice(j, 1); //删除取消赞的mid
              }
            }
            --num;
            isshow = 0; //点赞的状态
            that.tjcirclelist[i].is_follow = num;
            localStorage.setItem("okfollow", cookie_mid.join(","));
          } else {
            isshow = 1; //点赞的状态
            ++num;
            that.tjcirclelist[i].is_follow = num;
            cookie_mid.unshift(item_id); //新增赞的mid
            localStorage.setItem("okfollow", cookie_mid.join(","));
          }
        }
      }

      gettofollowcircle(item_id).then(res => {
        if (res.code == 200) {
          Toast({
            message: res.message,
            icon: "success"
          });
        } else {
          Toast.fail("关注失败！");
        }
      });
    },

    gotourl (liindex) {
      switch (liindex) {
        case 0:
          this.$router.push({ name: "circlelist" });
          //this.liindex = 0;
          break;
        case 1:
          this.$router.push({ name: "circlefollow" });
          //this.liindex = 1;
          break;
        case 2:
          this.$router.push({ name: "circlevisit" });
          //this.liindex = 2;
          break;
      }
    },
    changetabbar: function () {
      //判断当前的路由所在区域给
      this.onPath = this.$route.path;
      if (this.onPath == "/circlevisit") {
        this.liindex = 2;
      } else if (this.onPath == "/circlefollow") {
        this.liindex = 1;
      } else if (this.onPath == "/circlelist") {
        this.liindex = 0;
      }
    },

    onLoad () {
      // 异步更新数据
      setTimeout(() => {
        let cirid = this.cirid;
        var page = this.page;
        let that = this;
        let pageCount = this.pageCount;
        page++;
        if (page > pageCount) {
          return;
        }
        this.page = page;

        getothercirclelist(cirid, page).then(res => {
          if (res.data.code == 200) {
            this.loading = false;
            let mytjcirclearr = that.tjcirclelist;
            let newarr = res.data.data.list;
            newarr.forEach(function (e) {
              mytjcirclearr.push(e);
            });
            this.finished = true;
          }
        });
      }, 500);
    }
  },
  activated () {
    this.changetabbar();
    this.yikaishi();
  }
};
</script>

<style>
.van-field__control {
  font-size: 0.68rem !important;
}
.van-search {
  padding: 0.54rem 0.64rem !important;
}
.van-field__left-icon .van-icon {
  font-size: 0.86rem !important;
}
.van-search__content--round {
  border-radius: 0.9rem !important;
}
.van-search .van-cell {
  padding: 0.26rem 0.42rem 0.26rem 0 !important;
}
</style>

<style scoped>
.circlelist_container {
  height: 100%;
  padding-bottom: 3rem;
}
.clear {
  clear: both;
}
.circlesobox {
  background: #f8f8f8;
  overflow: hidden;
}
.van-search {
  background: none;
}
.circlesobox dl {
}
.circlesobox dl dt {
  float: left;
  background: #fff;
}

.circlesobox dl dd {
  float: left;
  font-size: 0.68rem;
  color: #6699ff;
  /* padding-top: 0.85rem; */
  padding-top: 0.8rem;
  line-height: 24px;
}
.circlesobox dl dd .van-icon-plus {
  float: left;
  font-size: 0.6rem;
  margin-right: 0.1rem;
  line-height: 24px;
}
.circlesobox dl dd span {
  float: left;
}
.van-search__content {
  background: #fff;
  width: 14.1rem;
}

.circlesidebar {
  /* height: 27rem; */
  height: calc(100% - 55px);
  overflow-y: scroll;
  width: 4.6rem;
  float: left;
  background: #fff;
}
.van-sidebar {
  width: 4.3rem;
}
.van-sidebar-item {
  border-bottom: 1px solid #ddd;
  text-align: center;
  font-size: 0.75rem;
  width: 100%;
  padding: 20px 15px 20px 18px;
}
.van-sidebar-item--select {
  border: none;
  border-left: none;
  width: 100%;
  border-bottom: 1px solid #ddd;
  color: #ffbd0a;
}
.van-sidebar-item--select::after {
  border-left: 5px solid #ffbd0a;
}
.circlelistbox {
  float: left;
  /*   height: 27rem; */
  height: calc(100% - 55px);
  overflow-y: scroll;
  width: 15rem;
  background: #fff;
}

.circlelistbox .circlenrbox {
  padding-left: 0.3rem;
  padding-right: 0.3rem;
}
.circlelistbox .circlenrbox .circle-cell {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding-top: 0.8108108108108109rem;
  padding-bottom: 0.8108108108108109rem;
  border-bottom: 0.02702702702702703rem solid #f6f6f6;
  width: 14.5rem;
}
.circlelistbox .circlenrbox .circle-cell .circle-cell-pic {
  width: 2.16rem;
  height: 2.16rem;
  border-radius: 0.2702702702702703rem;
  overflow: hidden;
  position: relative;
}
.circlelistbox .circlenrbox .circle-cell .circle-cell-pic .circle-cell-pic-no {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(218, 135, 70, 0.9);
  height: 0.7027027027027027rem;
  line-height: 0.7rem;
  width: 100%;
  color: #fff;
  font-size: 0.42rem;
  text-align: center;
  border-radius: 0 0 0.2702702702702703rem 0.2702702702702703rem;
}
.circlelistbox .circlenrbox .circle-cell .circle-cell-pic img {
  width: 2.16rem;
  height: 2.16rem;
  border-radius: 0.2702702702702703rem;
}
.circlelistbox
  .circlenrbox
  .circle-cell
  .circle-cell-pic
  .circle-cell-pic-no
  img {
  width: 0.62rem;
  margin-top: 0.05rem;
  height: 0.38rem;
}
.circlelistbox
  .circlenrbox
  .circle-cell
  .circle-cell-pic
  .circle-cell-pic-no01 {
  background: rgba(246, 210, 84, 0.9);
  color: #eb7c3a;
}
.circlelistbox
  .circlenrbox
  .circle-cell
  .circle-cell-pic
  .circle-cell-pic-no02 {
  background: rgba(211, 224, 241, 0.9);
  color: #7a98b4;
}
.circlelistbox
  .circlenrbox
  .circle-cell
  .circle-cell-pic
  .circle-cell-pic-no03 {
  background: rgba(238, 147, 120, 0.9);
  color: #b04b32;
}
.circlelistbox .circlenrbox .circle-cell .circle-cell-name {
  flex: 7;
  padding-right: 0.2702702702702703rem;
  padding-left: 0.5rem;
}
.circlelistbox .circlenrbox .circle-cell .circle-cell-name .cname {
  font-size: 0.7567567567567568rem;
}
.circlelistbox .circlenrbox .circle-cell .circle-cell-name .ctext1 {
  font-size: 0.6486486486486487rem;
  color: #999999;
}
.circlelistbox .circlenrbox .circle-cell .circle-cell-name .ctext2 {
  font-size: 0.6486486486486487rem;
  color: #999999;
  padding-left: 0.5405405405405406rem;
}
.circlelistbox .circlenrbox .circle-cell .circle-cell-fllow {
  float: 3.5;
  padding-top: 0.2702702702702703rem;
  margin-top: 0.2rem;
}
.circlelistbox .circlenrbox .circle-cell .circle-cell-fllow button {
  font-size: 0.6216216216216216rem;
  background: #ffbd0a;
  border: none;
  width: 3.2432432432432434rem;
  height: 1.35rem;
  border-radius: 5px;
  display: block;
  color: #fff;
  padding: 0;
}
.circlelistbox .circlenrbox .circle-cell .circle-cell-fllow button.active {
  background: #dbdbdb;
  border: none;
}

.circletabbox .circleul {
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #efefef;
  padding: 0 1.2rem;
  padding-top: 0.5rem;
}
.circletabbox .circleul li {
  font-size: 0.81rem;
  text-align: center;
  color: #666666;
  flex: 0 0 33.333%;
}
.circletabbox .circleul li span {
  padding: 0.5rem 0;
  display: inline-block;
}
.circletabbox .circleul li.active {
  color: #ffbd0a;
}
.circletabbox .circleul li.active span {
  border-bottom: 3px solid #ffbd0a;
}

@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .circlelistbox {
    float: left;
    height: 30rem;
    overflow-y: scroll;
    width: 15.3rem;
  }
}
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .circlelistbox {
    float: left;
    height: 30rem;
    overflow-y: scroll;
    width: 15.3rem;
  }
}
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .circlelistbox {
    float: left;
    height: 30rem;
    overflow-y: scroll;
    width: 15.3rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/circlelist.vue